import { render, staticRenderFns } from "./DiagnosticoScreen.vue?vue&type=template&id=eb6f8340&scoped=true&"
import script from "./DiagnosticoScreen.vue?vue&type=script&lang=js&"
export * from "./DiagnosticoScreen.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticoScreen.vue?vue&type=style&index=0&id=eb6f8340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6f8340",
  null
  
)

export default component.exports